import Vue from 'vue'
import App from './App.vue'
// import "./registerServiceWorker"
import router from './router'
import vuetify from './plugins/vuetify'
import axios from './plugins/axios'
import store from './store'
import infiniteScroll from './plugins/vue-infinite-scroll'
import rules from './assets/rules'
import func from './assets/func'
import moment from './plugins/moment'
import 'moment-duration-format'
import VideoPlayer from 'vue-video-player'
import videojs from './plugins/video'
import 'material-icons/iconfont/material-icons.css'
import './plugins/auth-image'
import Vue2TouchEvents from 'vue2-touch-events'
import decimal from './plugins/decimal'
import VueEcho from './plugins/vue-echo'

Vue.use(Vue2TouchEvents, {
	namespace: 'touch-event'
})
Vue.use(infiniteScroll)
Vue.use(VideoPlayer)

Vue.config.productionTip = false
Vue.prototype.$videojs = videojs
Vue.prototype.$moment = moment
Vue.prototype.$rules = rules
Vue.prototype.$func = func
Vue.prototype.$TITLE = process.env.VUE_APP_TITLE
Vue.prototype.$HOST_URL = process.env.VUE_APP_HOST
Vue.prototype.$API_URL = process.env.VUE_APP_API
Vue.prototype.$EXCHANGE_RATE = parseInt(process.env.VUE_APP_EXCHANGE_RATE)
Vue.prototype.$SHIPPING_FEE = parseInt(process.env.VUE_APP_SHIPPING_FEE)
Vue.prototype.$resendTime = 60
Vue.prototype.$numeric = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105]
Vue.prototype.$funcKeys = [8, 9, 13, 16, 17, 18, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 112, 113, 114, 115,116, 117, 118, 119, 120, 121, 122, 123,  144, 145]
Vue.prototype.$accept_file_type = {
	image: 'image/png, image/svg, image/jpeg, image/gif',
	video: 'video/x-msvideo,video/mpeg,video/quicktime,video/mp4',
	audio: 'audio/mp3'
}
Vue.prototype.$product_types = [
	{text: '長片', value: 'video'},
	{text: '寫真', value: 'photo'},
	{text: '限時動態', value: 'story'},
	{text: '原味衣物', value: 'clothes'},
  {text: '聊天解鎖', value: 'chat'}
]
// By seconds
Vue.prototype.$video_duration = {
	video: {
		min: 60,
		max: 5400
	},
	story: {
		min: 30,
		max: 60
	},
	photo: {
		min: 30,
		max: 5400
	},
	clothes: {
		min: 30,
		max: 5400
	},
  chat: {
    min: 10,
    max: 300
  },
  chatroom_member: {
    min: 10,
    max: 30
  },
  chatroom_seller: {
    min: 10,
    max: 300
  }
}

// By MB
Vue.prototype.$image_size = {
	max: 5
}

// By second
Vue.prototype.$audio_length = {
  max: 10
}

Vue.prototype.$product_price_limit = {
  story: {
    min: 240,
    max: 600
  },
  chat: {
    min: 400,
    max: 4000
  },
}

Vue.prototype.$product_upload_rules = {
  image_default: 5,
  photo: {
    image: {
      min: {
        charged: 10,
        uncharged: 1
      },
      max: {
        charged: 50,
        uncharged: 5
      }
    },
    video: {
      min: 0,
      max: 1
    }
  },
  video: {
    image: {
      min: {
        charged: 0,
        uncharged: 0
      },
      max: {
        charged: 0,
        uncharged: 0
      }
    },
    video: {
      min: 1,
      max: 1
    }
  },
  story: {
    image: {
      min: {
        charged: 1,
        uncharged: 0
      },
      max: {
        charged: 1,
        uncharged: 0
      }
    },
    video: {
      min: 1,
      max: 1
    }
  },
  clothes: {
    image: {
      min: {
        charged: 0,
        uncharged: 1
      },
      max: {
        charged: 0,
        uncharged: 10
      }
    },
    video: {
      min: 0,
      max: 2
    }
  },
  chat: {
    image: {
      min: {
        charged: 0,
        uncharged: 0
      },
      max: {
        charged: 1,
        uncharged: 0
      }
    },
    video: {
      min: 0,
      max: 1
    }
  },
}

let numberOfTypes = [
	{type: 'member', prefix: 'MB'},
	{type: 'seller', prefix: 'GL'},
	{type: 'story', prefix: 'LT'},
	{type: 'photo', prefix: 'PA'},
	{type: 'video', prefix: 'LF'},
	{type: 'clothes', prefix: 'CT'},
	{type: 'chat', prefix: 'CH'}
]

numberOfTypes.forEach(data => {
	Vue.filter(data.type, id => {
		return data.prefix + id.toString().padStart(9, '0')
	})
})

Vue.filter('filter', (value, filter) => {
  return Vue.filter(filter)(value)
})


var vm = new Vue({
	router,
	vuetify,
	store,
	render: h => h(App),
}).$mount('#app')
window.vm = vm
